import React from 'react';

import references from '../../../css-library/tokens/reference';
import { IconSizes } from '../../../visuals/Icons/type';
import InfoIcon from '../../../visuals/Icons/Info';

interface IInfoTextProps {
  children: React.ReactNode;
}

export const InfoText: React.FC<IInfoTextProps> = ({ children }) => {
  return (
    <span className="tw-lf-input-info-message tw-lf-form-input-bottom-message tw-flex tw-grid-area-[text] group-[.text-input-action]:tw-ml-2 peer-invalid:tw-hidden peer-[:not(:placeholder-shown)]:peer-valid:tw-hidden">
      <InfoIcon color={references.colors.black[1000]} size={IconSizes.sm} />
      <span className="tw-lf-input-info-message">{children}</span>
    </span>
  );
};
